export enum TipoTracciatoAvp {
  BASE = 0,
  CARICOSCARICO = 1,
  CARICORIGA = 2
}

export const TIPO_TRACCIATO_AVP = [
  { value: TipoTracciatoAvp.BASE, label: 'Base (705)' },
  { value: TipoTracciatoAvp.CARICOSCARICO, label: 'Carico/Scarico (711:701,703,706)' },
  { value: TipoTracciatoAvp.CARICORIGA, label: 'Carico Riga (702)' }
];
